import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { TooltipHost, TooltipDelay, DirectionalHint } from 'office-ui-fabric-react';
import cn from 'classnames';
import './TFTooltip.less';
/** v9 `PositioningShorthand` → Fabric `DirectionalHint`. Keys are the whole `TFTooltipPositioning` union (Record enforces it). */ export var POSITION_TO_HINT = {
    above: DirectionalHint.topCenter,
    'above-start': DirectionalHint.topLeftEdge,
    'above-end': DirectionalHint.topRightEdge,
    below: DirectionalHint.bottomCenter,
    'below-start': DirectionalHint.bottomLeftEdge,
    'below-end': DirectionalHint.bottomRightEdge,
    before: DirectionalHint.leftCenter,
    'before-top': DirectionalHint.leftTopEdge,
    'before-bottom': DirectionalHint.leftBottomEdge,
    after: DirectionalHint.rightCenter,
    'after-top': DirectionalHint.rightTopEdge,
    'after-bottom': DirectionalHint.rightBottomEdge
};
/** Fabric has three fixed delays (0 / 300 / 500 ms); snap a v9-style ms value to the nearest. 150 and 400 are the midpoints of Fabric's 0 / 300 / 500. */ export var toTooltipDelay = function toTooltipDelay(ms) {
    if (ms < 150) return TooltipDelay.zero;
    if (ms < 400) return TooltipDelay.medium;
    return TooltipDelay.long;
};
// csstype and merge-styles disagree only on vendor-prefixed keys; the values are runtime-compatible.
var toRawStyle = function toRawStyle(style) {
    return style;
};
/** v9's tooltip `offset` without an arrow (with one it becomes 4 + arrowHeight 6); Fabric's beak fills that gap on its own. */ var NO_ARROW_GAP_PX = 4;
/** Tags the callout with its variant for `TFTooltip.less`; `styles` stays `undefined` when nothing is set, so Fabric keeps its defaults. */ export var toCalloutProps = function toCalloutProps(param) {
    var _param_variant = param.variant, variant = _param_variant === void 0 ? 'normal' : _param_variant, _param_withArrow = param.withArrow, withArrow = _param_withArrow === void 0 ? true : _param_withArrow, calloutClassName = param.calloutClassName, calloutStyle = param.calloutStyle, contentStyle = param.contentStyle;
    return _object_spread_props(_object_spread({
        className: cn("tf-tooltip--".concat(variant), calloutClassName),
        isBeakVisible: withArrow
    }, !withArrow && {
        gapSpace: NO_ARROW_GAP_PX
    }), {
        styles: calloutStyle || contentStyle ? {
            root: toRawStyle(calloutStyle),
            calloutMain: toRawStyle(contentStyle)
        } : undefined
    });
};
export var TFTooltipFabric = function TFTooltipFabric(param) {
    var content = param.content, children = param.children, variant = param.variant, withArrow = param.withArrow, _param_positioning = param.positioning, positioning = _param_positioning === void 0 ? 'above' : _param_positioning, relationship = param.relationship, onVisibleChange = param.onVisibleChange, _param_showDelay = param.showDelay, showDelay = _param_showDelay === void 0 ? 300 : _param_showDelay, hideDelay = param.hideDelay, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, maxWidth = param.maxWidth, hostClassName = param.hostClassName, hostStyle = param.hostStyle, calloutClassName = param.calloutClassName, calloutStyle = param.calloutStyle, contentStyle = param.contentStyle;
    var suppressed = disabled || !content && content !== 0;
    var trigger = relationship === 'label' && typeof content === 'string' ? /*#__PURE__*/ React.cloneElement(children, {
        'aria-label': content
    }) : children;
    return /*#__PURE__*/ _jsx(TooltipHost, {
        content: suppressed ? undefined : /*#__PURE__*/ _jsx(_Fragment, {
            children: content
        }),
        setAriaDescribedBy: relationship === 'description',
        directionalHint: POSITION_TO_HINT[positioning],
        delay: toTooltipDelay(showDelay),
        closeDelay: hideDelay,
        onTooltipToggle: function onTooltipToggle(visible) {
            return (!visible || !suppressed) && (onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(undefined, {
                visible: visible
            }));
        },
        calloutProps: toCalloutProps({
            variant: variant,
            withArrow: withArrow,
            calloutClassName: calloutClassName,
            calloutStyle: calloutStyle,
            contentStyle: contentStyle
        }),
        hostClassName: cn('tf-tooltip-host', hostClassName),
        styles: {
            root: toRawStyle(hostStyle)
        },
        tooltipProps: {
            maxWidth: maxWidth !== undefined ? "".concat(maxWidth, "px") : undefined
        },
        children: trigger
    });
};
